import { render, staticRenderFns } from "./registered.vue?vue&type=template&id=35163c06&"
import script from "./registered.vue?vue&type=script&lang=ts&"
export * from "./registered.vue?vue&type=script&lang=ts&"
import style0 from "./registered.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports